// PrintableContent.js
import React from 'react';

const PrintableContent = React.forwardRef((props, ref) => {
    return (
        <div ref={ref}>
            hello <br />
            I am king <br />
            Nice to meet you
        </div>
    );
});

export default PrintableContent;